import { render, staticRenderFns } from "./xePieSetting.vue?vue&type=template&id=7a44b932"
import script from "./xePieSetting.vue?vue&type=script&lang=js"
export * from "./xePieSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports